//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { isUserAd } from '../AccentHeaderLayout/Header/Userbox';
import { ClinicDTO } from '../DashboardApi/api';
import { REACT_APP_LOGIN_PAGE } from '../../KeyVariables';

export class ControlsClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();
        this.instance.interceptors.request.use(
          config => {
              const token = localStorage.getItem('accessToken');
              if (token) {
                  if (!config.headers) {
                      config.headers = {};
                  }
                  config.headers['Authorization'] = `Bearer ${token}`;
              }
              return config;
          },
          error => {
              return Promise.reject(error);
          }
      );
      this.instance.interceptors.response.use(
        response => response,
        error => {
            if (error.response && error.response.status === 401) {
                const token = localStorage.getItem('accessToken');
                if (token) {
                    if (isUserAd(token)) {
                        window.location.href = REACT_APP_LOGIN_PAGE;
                    } else {
                        window.location.href = REACT_APP_LOGIN_PAGE;
                    }
                } else {
                    window.location.href = REACT_APP_LOGIN_PAGE;
                }
            }
            return Promise.reject(error);
        }
    );
    this.baseUrl = baseUrl ?? "";

  }

  /**
   * @param districtId (optional) 
   * @return OK
   */
  gettownsbydisctrict(districtId?: number | undefined, cancelToken?: CancelToken): Promise<ModelEntityDTO[]> {
    let url_ = this.baseUrl + "/api/address/gettownsbydisctrict?";
    if (districtId === null)
      throw new Error("The parameter 'districtId' cannot be null.");
    else if (districtId !== undefined)
      url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGettownsbydisctrict(_response);
    });
  }

  protected processGettownsbydisctrict(response: AxiosResponse): Promise<ModelEntityDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ModelEntityDTO.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<ModelEntityDTO[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ModelEntityDTO[]>(null as any);
  }
  /**
   * @param fullTypeName (optional) 
   * @param lng (optional) 
   * @param translatable (optional) 
   * @return OK
   */
  getmodelvalues(fullTypeName?: string | undefined, lng?: string | undefined, translatable?: boolean | undefined, cancelToken?: CancelToken): Promise<ModelEntityDTO[]> {
    let url_ = this.baseUrl + "/api/values/getmodelvalues?";
    if (fullTypeName === null)
      throw new Error("The parameter 'fullTypeName' cannot be null.");
    else if (fullTypeName !== undefined)
      url_ += "fullTypeName=" + encodeURIComponent("" + fullTypeName) + "&";
    if (lng === null)
      throw new Error("The parameter 'lng' cannot be null.");
    else if (lng !== undefined)
      url_ += "lng=" + encodeURIComponent("" + lng) + "&";
    if (translatable === null)
      throw new Error("The parameter 'translatable' cannot be null.");
    else if (translatable !== undefined)
      url_ += "translatable=" + encodeURIComponent("" + translatable) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetmodelvalues(_response);
    });
  }

  protected processGetmodelvalues(response: AxiosResponse): Promise<ModelEntityDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ModelEntityDTO.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<ModelEntityDTO[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ModelEntityDTO[]>(null as any);
  }

  /**
   * @param fullTypeName (optional) 
   * @param id (optional) 
   * @param lng (optional) 
   * @param translatable (optional) 
   * @return OK
   */
  getmodelvaluebyid(fullTypeName?: string | undefined, id?: number | undefined, lng?: string | undefined, translatable?: boolean | undefined, cancelToken?: CancelToken): Promise<ModelEntityDTO> {
    let url_ = this.baseUrl + "/api/values/getmodelvaluebyid?";
    if (fullTypeName === null)
      throw new Error("The parameter 'fullTypeName' cannot be null.");
    else if (fullTypeName !== undefined)
      url_ += "fullTypeName=" + encodeURIComponent("" + fullTypeName) + "&";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    if (lng === null)
      throw new Error("The parameter 'lng' cannot be null.");
    else if (lng !== undefined)
      url_ += "lng=" + encodeURIComponent("" + lng) + "&";
    if (translatable === null)
      throw new Error("The parameter 'translatable' cannot be null.");
    else if (translatable !== undefined)
      url_ += "translatable=" + encodeURIComponent("" + translatable) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetmodelvaluebyid(_response);
    });
  }

  protected processGetmodelvaluebyid(response: AxiosResponse): Promise<ModelEntityDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ModelEntityDTO.fromJS(resultData200);
      return Promise.resolve<ModelEntityDTO>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ModelEntityDTO>(null as any);
  }

  /**
   * @param fullTypeName (optional) 
   * @param filter (optional) 
   * @param lng (optional) 
   * @param translatable (optional) 
   * @return OK
   */
  autocomplete(fullTypeName?: string | undefined, filter?: string | undefined, lng?: string | undefined, translatable?: boolean | undefined, cancelToken?: CancelToken): Promise<ModelEntityDTO[]> {
    let url_ = this.baseUrl + "/api/values/autocomplete?";
    if (fullTypeName === null)
      throw new Error("The parameter 'fullTypeName' cannot be null.");
    else if (fullTypeName !== undefined)
      url_ += "fullTypeName=" + encodeURIComponent("" + fullTypeName) + "&";
    if (filter === null)
      throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined)
      url_ += "filter=" + encodeURIComponent("" + filter) + "&";
    if (lng === null)
      throw new Error("The parameter 'lng' cannot be null.");
    else if (lng !== undefined)
      url_ += "lng=" + encodeURIComponent("" + lng) + "&";
    if (translatable === null)
      throw new Error("The parameter 'translatable' cannot be null.");
    else if (translatable !== undefined)
      url_ += "translatable=" + encodeURIComponent("" + translatable) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processAutocomplete(_response);
    });
  }

  protected processAutocomplete(response: AxiosResponse): Promise<ModelEntityDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ModelEntityDTO.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<ModelEntityDTO[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ModelEntityDTO[]>(null as any);
  }

  /**
   * @param fullTypeName (optional) 
   * @param tag (optional) 
   * @return OK
   */
  getidbytag(fullTypeName?: string | undefined, tag?: string | undefined, cancelToken?: CancelToken): Promise<number> {
    let url_ = this.baseUrl + "/api/values/getidbytag?";
    if (fullTypeName === null)
      throw new Error("The parameter 'fullTypeName' cannot be null.");
    else if (fullTypeName !== undefined)
      url_ += "fullTypeName=" + encodeURIComponent("" + fullTypeName) + "&";
    if (tag === null)
      throw new Error("The parameter 'tag' cannot be null.");
    else if (tag !== undefined)
      url_ += "tag=" + encodeURIComponent("" + tag) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetidbytag(_response);
    });
  }

  protected processGetidbytag(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<number>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<number>(null as any);
  }



  doctorbyId(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<ModelEntityDTO> {
    let url_ = this.baseUrl + "/api/controls/doctor/doctorbyId?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDoctorbyId(_response);
    });
  }

  protected processDoctorbyId(response: AxiosResponse): Promise<ModelEntityDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ModelEntityDTO.fromJS(resultData200);
      return Promise.resolve<ModelEntityDTO>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ModelEntityDTO>(null as any);
  }
  doctorsbymedicalprofile(body: MedicalProfileDTO | undefined, cancelToken?: CancelToken | undefined): Promise<ModelEntityDTO[]> {
    let url_ = this.baseUrl + "/api/controls/doctor/doctorsbymedicalprofile";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDoctorsbymedicalprofile(_response);
    });
  }

  protected processDoctorsbymedicalprofile(response: AxiosResponse): Promise<ModelEntityDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ModelEntityDTO.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<ModelEntityDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelEntityDTO[]>(null as any);
    }
    doctorsbyoffice(body?: OfficeDTO | undefined, cancelToken?: CancelToken | undefined): Promise<ModelEntityDTO[]> {
        let url_ = this.baseUrl + "/api/controls/doctor/doctorsbyoffice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDoctorsbyoffice(_response);
        });
    }

    protected processDoctorsbyoffice(response: AxiosResponse): Promise<ModelEntityDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ModelEntityDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ModelEntityDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelEntityDTO[]>(null as any);
    }

}

export class ModelEntityDTO implements IModelEntityDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IModelEntityDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
    }
  }

  static fromJS(data: any): ModelEntityDTO {
    data = typeof data === 'object' ? data : {};
    let result = new ModelEntityDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    return data;
  }
}
export class MedicalProfileDTO implements IMedicalProfileDTO {
  id?: number;
  name?: string | null;
  nurseType?: BaseNomDTO;

  constructor(data?: IMedicalProfileDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
          this.nurseType = _data["nurseType"] ? BaseNomDTO.fromJS(_data["nurseType"]) : <any>null;
      }
  }

  static fromJS(data: any): MedicalProfileDTO {
      data = typeof data === 'object' ? data : {};
      let result = new MedicalProfileDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      data["nurseType"] = this.nurseType ? this.nurseType.toJSON() : <any>null;
      return data;
  }
}
export class BaseNomDTO implements IBaseNomDTO {
  id?: number;
  name?: string | null;
  tag?: string | null;
  color?: string | null;

  constructor(data?: IBaseNomDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
          this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
          this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
      }
  }

  static fromJS(data: any): BaseNomDTO {
      data = typeof data === 'object' ? data : {};
      let result = new BaseNomDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      data["tag"] = this.tag !== undefined ? this.tag : <any>null;
      data["color"] = this.color !== undefined ? this.color : <any>null;
      return data;
  }
}

export interface IBaseNomDTO {
  id?: number;
  name?: string | null;
  tag?: string | null;
  color?: string | null;
}
export interface IMedicalProfileDTO {
  id?: number;
  name?: string | null;
  nurseType?: BaseNomDTO;
}
export interface IModelEntityDTO {
  id?: number;
  name?: string | null;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}
export class OfficeDTO implements IOfficeDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    clinic?: ClinicDTO;

    constructor(data?: IOfficeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.clinic = _data["clinic"] ? ClinicDTO.fromJS(_data["clinic"]) : <any>null;
        }
    }

    static fromJS(data: any): OfficeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["clinic"] = this.clinic ? this.clinic.toJSON() : <any>null;
        return data;
    }
}

export interface IOfficeDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    clinic?: ClinicDTO;
}
function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
  if (result !== null && result !== undefined)
    throw result;
  else
    throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}